import SessionStorage from './SessionStorage';

export interface IBlackbox {
    FirstParty: unknown,
    ThirdParty: unknown,
    IpAddress: string | null,
    HostName: string,
}

export interface IDeviceInfo {
    Blackbox: IBlackbox,
    BlackboxReadTimeout: boolean,
    TPBlackboxError: string,
    FPBlackboxError: string,
    VendorFPBBError: unknown,
    VendorTPBBError: unknown
}

class BlackboxUtils {

    private deviceInfo?: IDeviceInfo;

    constructor() {
        this.setBlackbox();
    }

    private isIovationPresent = (): boolean => {
        return typeof window !== 'undefined' && (window as any).IGLOO && typeof (window as any).IGLOO.getBlackbox === 'function';
    };

    private setBlackbox = (): void => {
        if (!this.isIovationPresent()) {
            // eslint-disable-next-line no-console
            console.debug('DeviceInformationProvider: toggleDevice(): window.IGLOO.getBlackox DNE...');
            return;
        }

        const blackboxInfo: string = (window as any).IGLOO.getBlackbox().blackbox;
        const blackboxInfoArr = blackboxInfo ? blackboxInfo.split(';') : [];

        this.deviceInfo = {
            Blackbox: {
                FirstParty: blackboxInfoArr[0] ? blackboxInfoArr[0] : '',
                ThirdParty: blackboxInfoArr[1] ? blackboxInfoArr[1] : '',
                IpAddress: SessionStorage.tryGet('protocol', ''),
                HostName: window.location.hostname,
            },
            BlackboxReadTimeout: true,
            FPBlackboxError: '',
            TPBlackboxError: '',
            VendorFPBBError: (window as any).fp_last_error,
            VendorTPBBError: (window as any).io_last_error,
        };
    };

    public getBlackbox = (): IDeviceInfo | undefined => {
        if (!this.deviceInfo) {
            this.setBlackbox();
        }
        return this.deviceInfo;
    };

}

export const blackboxUtils = new BlackboxUtils();